import { FormGroup, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ChecklistAnswerType } from "../../../../types/actionModule/subtypes/checklistAnswerSubtype";
import { PropertyEditorProps } from "../../../../types/actionModule/editor/subtypeEditorTypes";

export function ChecklistAnswerTypeEditor(props: PropertyEditorProps) {
    const { t } = useTranslation();
    return <FormGroup>
        <RadioGroup
            value={props.value}
            onChange={(e) => props.onChanged(e.target.value)}>
            <FormControlLabel
                value={"SingleChoice" as ChecklistAnswerType}
                control={<Radio />}
                label={t("actionModules.subtypes.checklistAnswer.checklistAnswerTypeSingleChoice")} />
            <FormControlLabel
                value={"MultipleChoice" as ChecklistAnswerType}
                control={<Radio />}
                label={t("actionModules.subtypes.checklistAnswer.checklistAnswerTypeMultipleChoice")} />
            <FormControlLabel
                value={"MultipleChoiceWithDecline" as ChecklistAnswerType}
                control={<Radio />}
                label={t("actionModules.subtypes.checklistAnswer.checklistAnswerTypeMultipleChoiceWithDecline")} />
        </RadioGroup>
    </FormGroup>
}